// HTML input types that do not cause the software keyboard to appear.
const nonTextInputTypes = new Set(['checkbox', 'radio', 'range', 'color', 'file', 'image', 'button', 'submit', 'reset']);
const elementRevealsVirtualKeyboardOnFocus = element => {
  if (element instanceof HTMLTextAreaElement) {
    return true;
  }
  if (element instanceof HTMLInputElement && !nonTextInputTypes.has(element.type)) {
    return true;
  }
  return false;
};
var elementRevealsVirtualKeyboardOnFocus$1 = elementRevealsVirtualKeyboardOnFocus;

export { elementRevealsVirtualKeyboardOnFocus$1 as e };
//# sourceMappingURL=elementRevealsVirtualKeyboardOnFocus-72bd96fa-a02066f2.js.map
